var map = {
	"./marker-icon-2x-black.png": 3239,
	"./marker-icon-2x-blue.png": 3822,
	"./marker-icon-2x-gold.png": 6672,
	"./marker-icon-2x-green.png": 1079,
	"./marker-icon-2x-grey.png": 4573,
	"./marker-icon-2x-orange.png": 7592,
	"./marker-icon-2x-red.png": 5396,
	"./marker-icon-2x-violet.png": 7573,
	"./marker-icon-2x-yellow.png": 9349,
	"./marker-icon-black.png": 5299,
	"./marker-icon-blue.png": 6521,
	"./marker-icon-gold.png": 7321,
	"./marker-icon-green.png": 459,
	"./marker-icon-grey.png": 1827,
	"./marker-icon-orange.png": 2371,
	"./marker-icon-red.png": 2130,
	"./marker-icon-violet.png": 7250,
	"./marker-icon-yellow.png": 3462
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 9097;